<template>
  <div class="intro">
    <div class="intro-inner">
      <h1>Daily<br>Report</h1>
      <router-link :to="todayUrl" class="button">START</router-link>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Intro',
  components: {

  },
  props: [

  ],
  data() {
    return {
    };
  },
  methods: {

  },
  computed: {
    todayUrl() {
      let today = moment(new Date()).format('YYYY-MM-DD');
      return '/day/' + today;
    }
  },
  created() {

  },
  watch: {

  }
};

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue